/* eslint-disable max-len */
import React from 'react';
import { Box, Modal, Grid, Tooltip } from '@mui/material';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';

const TipsPopup = (props) => {
  const { visibleRoTips, closeRoTipsPopup, translateObject } = props;
  return (
    <Modal
      hideBackdrop
      open={visibleRoTips}
      onClose={closeRoTipsPopup}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="ro-modal"
    >
      <Box className=''>
        <Rnd
          default={{
            width: '80%',
            height: '80%',
            x: ((window.innerWidth / 2) - ((80 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((80 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick={false}
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='47%'
          cancel=".no_drag"
          className='roDGT-grid-container'>
          <Box>
            <Grid container className="roDGT-grid">
              <Grid item xs={12} className="roDGT-header-grid">
                <div className="roDGT-header-text rufusBld no_drag">
                  {translateObject('Tips on Designing RO Units Operating on Natural Waters with Below 5000 mg/L TDS')}</div>
                <div className="roDGT-close-icon no_drag">
                  <Tooltip title="Close">
                    <img src={closeIconBlack} alt="close" onClick={closeRoTipsPopup} style={{ width: '14px', padding: '11px' }}
                      className="pointer" />
                  </Tooltip>
                </div>
              </Grid>
              <Grid container className='roDGT-body-grid'>
                <Grid item xs={12} style={{ 'padding': '10px 2vw 10px 10px' }}>
                  <ul>
                    <p className='sansW4SeLig no_drag subtext_size'>
                      {translateObject('Text1')}
                      <sup>6</sup> {translateObject('Text2')}</p>
                  </ul>
                </Grid>
                <Grid item xs={12} style={{ 'padding': '10px 2vw 10px 10px' }}>
                  <ol>
                    <li>
                      <h4 className='sansW7Bld no_drag text_size'>{translateObject('Determine which RO elements to use.')}</h4>
                      <ol type='a'>
                        <li className='sansW4SeLig no_drag subtext_size'>
                          {translateObject('Text3')}
                          <sup>2</sup> {translateObject('Text4')}
                        </li>
                      </ol>
                    </li>
                    <li>
                      <h4 className='sansW7Bld no_drag text_size'>{translateObject('Determine approximate number of RO elements')}</h4>
                      <ol type='a'>
                        <li className='sansW4SeLig no_drag subtext_size'>{translateObject('Text5')}</li>
                        <li className='sansW4SeLig no_drag subtext_size'>{translateObject('Text6')}</li>
                      </ol>
                    </li>
                    <p className='sansW4SeLig no_drag subtext_size' style={{ 'padding-left': '32px' }}>
                      {translateObject('Text7')}</p>
                    <li>
                      <h4 className='sansW7Bld no_drag text_size'>{translateObject('Determine number of element housings.')}</h4>
                      <ol type='a'>
                        <li className='sansW4SeLig no_drag subtext_size'>{translateObject('Text8')}</li>
                      </ol>
                    </li>
                    <li>
                      <h4 className='sansW7Bld no_drag text_size'>{translateObject('Determine array.')}</h4>
                      <ol type='a'>
                        <li className='sansW4SeLig no_drag subtext_size'>
                          {translateObject('The below table is used to determine how to approximately arrange the housings.')}</li>
                        <div className='array_table'>
                          <table>
                            <tr className='tHead'>
                              <th className='no_drag ' style={{ borderRadius: '6px 0 0 0' }}>{translateObject('Permeate Recovery, %')}</th>
                              <th className='no_drag'>{translateObject('Typical array*')}</th>
                              <th className='no_drag ' style={{ borderRadius: '0 6px 0 0' }}>
                                {translateObject('Housings in 1')}<sup>st</sup> stage</th>
                            </tr>
                            <tr className='tBody'>
                              <td className='no_drag'>  65-80  </td>
                              <td className='no_drag'> 2-1 </td>
                              <td className='no_drag'>2/3 of total</td>
                            </tr>
                            <tr className='tBody tbdy'>
                              <td className='no_drag' style={{ borderRadius: '0 0 0 6px ' }}> 80-90    </td>
                              <td className='no_drag'> 4-2-1</td>
                              <td className='no_drag' style={{ borderRadius: '0 0 6px 0' }}>4/7 of total</td>
                            </tr>
                          </table>
                        </div>
                      </ol>
                    </li>
                    <p className='sansW4SeLig no_drag subtext_size' style={{ 'padding-left': '40px' }}>{translateObject('* or multiple of it')}</p>
                    <p className='sansW4SeLig no_drag subtext_size' style={{ 'padding-left': '35px' }}>
                      {translateObject('Text9')}</p>
                    <li><h4 className='sansW7Bld no_drag text_size'>{translateObject('Run Winflows Design Simulator with the 24-12 array and look for')}</h4>
                      <ol type='a'>
                        <li className='sansW4SeLig no_drag subtext_size'>{translateObject('Warnings')}</li>
                        <li className='sansW4SeLig no_drag subtext_size'>{`Element permeate recovery
                    (shown in Winflows Design Simulator Explorer) not too high <15-20%.
                     The lower the permeate flux, the higher element recovery is acceptable`}</li>
                        <li className='sansW4SeLig no_drag subtext_size'>{translateObject('Text10')}</li>
                        <li className='sansW4SeLig no_drag subtext_size'>
                          {translateObject('The pressure drop over the elements')}</li>
                        <li className='sansW4SeLig no_drag subtext_size'>
                          {translateObject('The predicted permeate TDS should be below the maximum allowed.')}</li>
                      </ol>
                    </li>
                  </ol>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Rnd>
      </Box>
    </Modal>
  );
};

export default TipsPopup;